import { FC } from 'react';
import { Box, Theme, Typography, useTheme } from '@mui/material';
import { observer } from 'mobx-react-lite';

interface ScorePillProps {
  score: number | null;
  size?: 'sm' | 'md';
}

const palette = (score: number, theme: Theme) => {
  if (score >= 80) {
    return { color: theme.palette.green[700], bg: theme.palette.green[200] };
  }
  if (score >= 60) {
    return { color: theme.palette.blue[700], bg: theme.palette.blue[200] };
  }
  return { color: theme.palette.red[500], bg: theme.palette.red[100] };
};

export const ScorePill: FC<ScorePillProps> = observer(({ score, size = 'md' }) => {
  const theme = useTheme();

  if (score === null || score === undefined) {
    return (
      <Typography
        variant="body2"
        sx={{
          color: theme.palette.text.tertiary,
          fontSize: size === 'sm' ? 12 : 13,
        }}
      >
        —
      </Typography>
    );
  }

  const { color, bg } = palette(score, theme);

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        fontSize: size === 'sm' ? 12 : 13,
        fontWeight: 600,
        color,
        backgroundColor: bg,
        paddingY: 0.25,
        paddingX: size === 'sm' ? 1 : 1.25,
        borderRadius: 9999,
        border: `1px solid ${color}22`,
        lineHeight: 1.5,
      }}
    >
      {score}%
    </Box>
  );
});
